/* eslint-disable max-len */
const React = require('react');

const PluginNuvemShop = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="49" viewBox="0 0 54 49">
    <path fill="#2C2F4B" d="M32.366 10.713h-.027c-3.587 0-6.982 1.457-9.528 4.057-1.287-.571-2.71-.885-4.161-.885C12.79 13.885 8 18.856 8 25s4.764 11.115 10.65 11.115c1.423 0 2.847-.314 4.134-.885 2.464 2.514 5.831 4.057 9.527 4.057C39.867 39.287 46 32.887 46 25c.027-7.858-6.105-14.287-13.634-14.287zm-.106 25.33c-5.802 0-10.547-4.94-10.547-11.043h-3.01c0 2.782.76 5.394 2.088 7.58-.677.198-1.382.312-2.087.312-4.148 0-7.537-3.549-7.537-7.892s3.389-7.892 7.537-7.892c1.654 0 3.199.54 4.527 1.59 1.925 1.504 3.01 3.804 3.01 6.302h3.036c0-3.293-1.355-6.36-3.768-8.46 1.898-1.646 4.283-2.583 6.778-2.583 5.802 0 10.546 4.968 10.546 11.043-.027 6.075-4.744 11.043-10.573 11.043z" />
  </svg>
);

module.exports = PluginNuvemShop;
